export default __webpack_public_path__ + "static/media/Radiant@3x.0b219164.png";